import { dialog } from "../../../../nq-component";
import { useState } from "react";

function DialogOptions({ onClickOption1, onClickOption2, onClickOption3 }) {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const options = [
    {
      label: "Flexible Entry",
      description: "Different date, supplier, and amount per entry",
      onClick: onClickOption1,
      borderColor: "#14213D",
      hoverColor: "rgba(20, 33, 61, 0.09)",
    },
    {
      label: "Batch By Date",
      description: "Same date, multiple suppliers",
      onClick: onClickOption2,
      borderColor: "#1B5E20",
      hoverColor: "rgba(27, 94, 31, 0.09)",
    },
    {
      label: "Grouped by Supplier",
      description: "Same supplier and date, many gross values",
      onClick: onClickOption3,
      borderColor: "#FCA311",
      hoverColor: "rgba(252, 162, 17, 0.09)",
    },
  ];

  const renderOptions = () => {
    return options.map((option, index) => (
      <div
        onMouseEnter={() => setHoveredIndex(index)}
        onMouseLeave={() => setHoveredIndex(null)}
        key={index}
        className="p-3 d-flex flex-column rounded-1 cursor-pointer"
        style={{
          border: `1px solid ${option.borderColor}`,
          transition: "ease-in-out",
          //   backgroundColor: `${options[hoveredIndex].hoverColor}`,
          backgroundColor:
            hoveredIndex === index ? options[hoveredIndex].hoverColor : "",
          transition: "background-color 0.1s",
        }}
        onClick={option.onClick}
      >
        <div className="d-flex justify-content-between">
          <label>{option.label}</label>
          <i className="bi bi-chevron-right"></i>
        </div>
        <small className="text-muted">{option.description}</small>
      </div>
    ));
  };

  return (
    <div className="p-4">
      <div className="d-flex flex-column gap-3">
        <div
          className="d-flex justify-content-between pb-1"
          style={{ borderBottom: "1px solid gray" }}
        >
          <p className="m-0">Transaction Entry Mode</p>
          <i
            className="bi bi-x-lg text-danger cursor-pointer"
            onClick={() => dialog.close()}
          ></i>
        </div>
        {renderOptions()}
      </div>
    </div>
  );
}

export default DialogOptions;
